export const MCQCategories = [
  { id: 1, option: "General Aptitude Test for Constables" },
  { id: 2, option: "Law & Ethics Test for Inspectors" },
  { id: 3, option: "Physical Fitness Knowledge Test" },
  { id: 4, option: "Criminal Justice Awareness Test" },
  { id: 5, option: "Communication Skills Assessment" },
  { id: 6, option: "Leadership & Strategy Test" },
  { id: 7, option: "Investigative Skills MCQ" },
  { id: 8, option: "ICT Competency Assessment" },
];

export const EducationQualificationsInfo = [
  { id: 1, option: "First School Leaving Certificate (FSLC)" },
  { id: 2, option: "West African Senior School Certificate (WASSCE)" },
  { id: 3, option: "National Examination Council (NECO) Certificate" },
  { id: 4, option: "National Diploma (ND)" },
  { id: 5, option: "Higher National Diploma (HND)" },
  { id: 6, option: "Bachelor of Science (B.Sc.)" },
  { id: 7, option: "Bachelor of Arts (B.A.)" },
  { id: 8, option: "Postgraduate Diploma (PGD)" },
  { id: 9, option: "Master of Science (M.Sc.)" },
  { id: 10, option: "Master of Arts (M.A.)" },
  { id: 11, option: "Doctor of Philosophy (PhD)" },
  { id: 12, option: "National Certificate in Education (NCE)" }
];

export const EducationLevelsInfo = [
  { id: 1, option: "Primary Education" },
  { id: 2, option: "Junior Secondary Education" },
  { id: 3, option: "Senior Secondary Education" },
  { id: 4, option: "Tertiary Education (Diploma, Bachelor's Degree, etc.)" },
  { id: 5, option: "Postgraduate Education (Master's, Ph.D.)" }
]

export const ReligionsInfo = [
  { id: 1, option: "Islam" },
  { id: 2, option: "Roman Catholicism" },
  { id: 3, option: "Yoruba Traditional Religion (Ifá, Orisha)" },
  { id: 4, option: "Tertiary Education (Diploma, Bachelor's Degree, etc.)" },
  { id: 5, option: "Igbo Traditional Religion (Odinani)" }
]

export const KinRelationshipInfo = [
  { id: 1, option: "Father" },
  { id: 2, option: "Mother" },
  { id: 3, option: "Spouse (Husband/Wife)" },
  { id: 4, option: "Uncle" },
  { id: 5, option: "Aunt" }
]

export const BaseAddressInfo = [
  { id: 1, option: "3 Diamond Hill Road",state:"Cross River State",city:"Calabar" },
  { id: 2, option: "Force Headquarters, Shehu Shagari Way, Central Business District",state:"FCT",city:"Abuja" },
  { id: 3, option: "1 Kam Salem House, Moloney Street",state:"Lagos State",city:"Onikan" },
  { id: 4, option: "1 Federal Secretariat Road",state:"Edo State",city:"Benin City" }
]

export const RejectionsInfo = [
  { id: 1, option: "Educational Qualification Not Met",value: "Educational Qualification Not Met",label: "Educational Qualification Not Met" },
  { id: 2, option: "Height Requirement Not Met",value: "Height Requirement Not Met",label: "Height Requirement Not Met" },
  { id: 3, option: "Age Limit Exceeded",value: "Age Limit Exceeded",label: "Age Limit Exceeded" },
  { id: 4, option: "Incomplete Application Details",value: "Incomplete Application Details",label: "Incomplete Application Details" },
  { id: 5, option: "Physical Test Failure",value: "Physical Test Failure",label: "Physical Test Failure" },
  { id: 6, option: "Document Verification Discrepancy" ,value: "Document Verification Discrepancy" ,label: "Document Verification Discrepancy" },
  { id: 7, option: "Certificate Falsification", value: "Certificate Falsification", label: "Certificate Falsification" },
  { id: 8, option: "Medical Screening Failed" , value: "Medical Screening Failed" , label: "Medical Screening Failed" },
  { id: 9, option: "Identity Mismatch",value: "Identity Mismatch",label: "Identity Mismatch" },
  { id: 10, option: "Other (Specify)",value: "Other (Specify)" ,label: "Other (Specify)" }
]

export const PhysicalScreeningInfo = [
  { id: 1, inputName: "Height (In Meters)", inputType: "Text" },
  { id: 2, inputName: "Weight (In Kg)", inputType: "Text" },
  { id: 3, inputName: "Chest Length (Expanded - in inches)", inputType: "Text" },
  { id: 4, inputName: "Chest Length (Unexpanded - in inches)", inputType: "Text" },
  { id: 5, inputName: "Select your dental condition (e.g., Healthy, Cavities)", inputType: "Text" },
  { id: 6, inputName: "Do you have flat feet?", inputType: "Check Box" },
  { id: 7, inputName: "Do you have squinting eyes?", inputType: "Check Box" },
  { id: 8, inputName: "Do you have bow legs?", inputType: "Check Box" },
];

export const MedicalScreeningInfo = [
  { id: 1, inputName: "Height (In Meters)", inputType: "Text" },
  { id: 2, inputName: "Weight (In Kg)", inputType: "Text" },
  { id: 3, inputName: "BMI Status", inputType: "Text" },
  { id: 4, inputName: "Systolic Pressure", inputType: "Text" },
  { id: 5, inputName: "Diastolic Pressure", inputType: "Text" },
  { id: 6, inputName: "Blood Group", inputType: "Text" }
];

export const CBTData = [
  {
    id: 1,
    name: "JAMB CBT Center",
    address: "JAMB National Headquarters",
    state: "FCT, Nigeria",
    city: "Bwari"
  },
  {
    id: 2,
    name: "Digital Bridge Institute",
    address: "No. 1 Nitel Road, Cappa Bus Stop",
    state: "Lagos State, Nigeria",
    city: "Oshodi"
  },
  {
    id: 3,
    name: "Yaba College of Technology (YABATECH)",
    address: "1, Yaba College of Technology Road",
    state: "Lagos State, Nigeria",
    city: "Yaba"
  },
  {
    id: 4,
    name: "University of Lagos (UNILAG) CBT Center",
    address: "University Road",
    state: "Lagos State, Nigeria",
    city: "Akoka-Yaba"
  },
  {
    id: 5,
    name: "Ahmadu Bello University (ABU) CBT Center",
    address: "Samaru Campus",
    state: "Kaduna State, Nigeria",
    city: "Zaria"
  }
];


export const PhysicalMedicalLocationsInfo = [
  {
    id: 1,
    name: "JAMB CBT Center",
    address: "JAMB National Headquarters",
    state: "FCT, Nigeria",
    city: "Bwari"
  },
  {
    id: 2,
    name: "Digital Bridge Institute",
    address: "No. 1 Nitel Road, Cappa Bus Stop",
    state: "Lagos State, Nigeria",
    city: "Oshodi"
  },
  {
    id: 3,
    name: "Yaba College of Technology (YABATECH)",
    address: "1, Yaba College of Technology Road",
    state: "Lagos State, Nigeria",
    city: "Yaba"
  },
  {
    id: 4,
    name: "University of Lagos (UNILAG) CBT Center",
    address: "University Road",
    state: "Lagos State, Nigeria",
    city: "Akoka-Yaba"
  },
  {
    id: 5,
    name: "Ahmadu Bello University (ABU) CBT Center",
    address: "Samaru Campus",
    state: "Kaduna State, Nigeria",
    city: "Zaria"
  }
];

export const TermsInfo = [
  {
    id: 1,
    title: "Introduction",
    content: "These Terms & Conditions govern your use of the PSC Nigeria portal. By accessing or using our services, you agree to comply with these terms and any applicable laws or regulations."
  },
  {
    id: 2,
    title: "Information We Collect",
    content: "You agree to provide accurate and complete information in your job applications. Misrepresentation of information may result in disqualification or legal consequences."
  },
  {
    id: 3,
    title: "Accountability",
    content: "You are responsible for maintaining the confidentiality of your account credentials. Any activity that occurs under your account is your responsibility."
  },
  {
    id: 4,
    title: "Modifications",
    content: "We reserve the right to modify or update these Terms & Conditions at any time. Changes will be effective immediately upon posting on the portal. Your continued use of the portal constitutes acceptance of the updated terms."
  },
  {
    id: 5,
    title: "Governing Law",
    content: "These Terms & Conditions are governed by the laws of Nigeria. Any disputes arising from your use of the portal will be resolved in accordance with Nigerian legal procedures."
  }
];

export const PrivacyPolicyInfo = [
  {
    id: 1,
    title: "Introduction",
    content: "Welcome to the Police Service Commission (PSC) Nigeria’s official portal. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our services."
  },
  {
    id: 2,
    title: "Information We Collect",
    content: "We collect personal information such as name, contact details, educational background, and employment history through forms and online submissions. This information is necessary for recruitment and verification purposes."
  },
  {
    id: 3,
    title: "Use of Information",
    content: "Your personal information is used to process job applications, verify qualifications, and communicate with you regarding recruitment activities. We may also use aggregated data for statistical analysis to improve our services."
  },
  {
    id: 4,
    title: "Sharing of Information",
    content: "We may share your information with relevant government agencies, educational institutions, and third-party service providers involved in the recruitment process. Your data is shared in accordance with applicable laws and regulations."
  },
  {
    id: 5,
    title: "Security",
    content: "We employ security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, secure data storage, and restricted access to authorized personnel only."
  }
];

export const FaqsInfo = [
  {
    id: 1,
    question: "What is the Police Service Commission (PSC) Nigeria?",
    answer: "The Police Service Commission (PSC) Nigeria is a government agency responsible for recruitment, promotion, and discipline within the Nigeria Police Force. It ensures transparency and accountability in police recruitment processes."
  },
  {
    id: 2,
    question: "How can I apply for a job with the Police Service Commission (PSC) Nigeria?",
    answer: "You agree to provide accurate and complete information in your job applications. Misrepresentation of information may result in disqualification or legal consequences."
  },
  {
    id: 3,
    question: "What are the eligibility criteria for applying to the PSC Nigeria?",
    answer: "You are responsible for maintaining the confidentiality of your account credentials. Any activity that occurs under your account is your responsibility."
  },
  {
    id: 4,
    question: "How will I know the status of my application with the Police Service Commission (PSC) Nigeria?",
    answer: "You can track the status of your application by logging into your account on the PSC Nigeria portal. Updates on Recruitment Workflow, such as shortlisting, examination dates, and final results, will be communicated through the portal and via registered email."
  },
  {
    id: 5,
    question: "What documents do I need to submit with my application?",
    answer: "Applicants are typically required to submit scanned copies of educational certificates, identification documents (e.g., National Identity Card), and any other documents specified in the job advertisement. Ensure all documents are clear and legible to facilitate the application review process."
  }
];